// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"terms_content-wrapper__TMOBF"};